module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 m-b-sm"
  }, [_c('div', {
    staticClass: "row table-filter"
  }, [_c('div', {
    staticClass: "col-sm-2 col-xs-12"
  }, [_c('h4', {
    staticClass: "table-name"
  }, [_vm._v(_vm._s(_vm.title))])])]), _vm._v(" "), _c('div', {
    staticClass: "b-b"
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "display": "none"
    },
    style: (_vm.view_mounted)
  }, [_c('form', {
    attrs: {
      "action": ""
    }
  }, [(_vm.action === 'add') ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-2 text-right label p-t-b-sm "
  }, [_vm._v("\n                复制岗位:\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-5 n-p-l"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.clone_post),
      expression: "clone_post",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input-md col-xs-12",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.clone_post = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "-1"
    }
  }, [_vm._v("请选择岗位")]), _vm._v(" "), _vm._l((_vm.posts), function(pt) {
    return (pt.clone_able === 1) ? _c('option', {
      key: pt._id,
      domProps: {
        "value": pt._id
      }
    }, [_vm._v(_vm._s(pt.name))]) : _vm._e()
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 p-t-b-sm n-p-l text-left"
  }, [_c('div', {
    staticClass: "left tooltips"
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  }), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("\n                    可以复制已有岗位所有数据。"), _c('br'), _vm._v("注意:自定数据会被覆盖。\n                  ")])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-2 text-right label p-t-b-sm"
  }, [_vm._v("\n                岗位名称:\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-5  n-p-l"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.post.name),
      expression: "post.name",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input input-md",
    attrs: {
      "type": "text",
      "placeholder": "岗位名称：Java开发工程师"
    },
    domProps: {
      "value": (_vm.post.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.post.name = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-5 label p-t-b-sm n-p-l text-left"
  }, [_vm._v("\n                *\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-2 text-right label p-t-b-sm"
  }, [_vm._v("\n                岗位别名:\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-5  n-p-l"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.post.alias),
      expression: "post.alias",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input input-md",
    attrs: {
      "type": "text",
      "placeholder": "岗位别名：Java开发工程师"
    },
    domProps: {
      "value": (_vm.post.alias)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.post.alias = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-5 label p-t-b-sm n-p-l text-left"
  }, [_c('div', {
    staticClass: "left tooltips"
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  }), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("\n                    岗位别名在发送邀请时显示，通过“-”分割，选择第一段。"), _c('br'), _vm._v("例如："), _c('br'), _vm._v("岗位名称："), _c('br'), _vm._v("“Java开发工程师-研发一部”，"), _c('br'), _vm._v("别名："), _c('br'), _vm._v("“Java开发工程师”\n                  ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-2 text-right label p-t-b-sm"
  }, [_vm._v("\n                关联能力群:\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8 n-p-l p-t-xs"
  }, [_c('button', {
    staticClass: "btn btn-success btn-sm left",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.selectAbilities()
      }
    }
  }, [_vm._v("关联能力群")]), _vm._v(" "), (_vm.ability_select_show) ? _c('div', {
    staticClass: "row "
  }, [_c('div', {
    staticClass: "col-xs-12 n-p-r m-t-sm"
  }, _vm._l((_vm.view_abilities), function(ability, ind) {
    return _c('div', {
      key: ability._id,
      staticClass: "col-xs-4 n-p-l m-b-sm"
    }, [_c('div', {
      staticClass: "btn col-xs-12",
      class: {
        'btn-danger': ind % 3 === 2, 'btn-success': ind % 3 === 0, 'btn-warning': ind % 3 === 1
      }
    }, [_vm._v(_vm._s(ability.name) + "\n                        "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (ability.is_selected),
        expression: "ability.is_selected",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "right",
      staticStyle: {
        "margin-top": "9px"
      },
      attrs: {
        "type": "checkbox",
        "true-value": 1,
        "false-value": 0
      },
      domProps: {
        "checked": Array.isArray(ability.is_selected) ? _vm._i(ability.is_selected, null) > -1 : _vm._q(ability.is_selected, 1)
      },
      on: {
        "__c": function($event) {
          var $$a = ability.is_selected,
            $$el = $event.target,
            $$c = $$el.checked ? (1) : (0);
          if (Array.isArray($$a)) {
            var $$v = _vm._n(null),
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (ability.is_selected = $$a.concat($$v))
            } else {
              $$i > -1 && (ability.is_selected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            ability.is_selected = $$c
          }
        }
      }
    })])])
  })), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 m-t-b-sm"
  }, [_c('div', {
    staticClass: "btn btn-sm btn-primary right",
    on: {
      "click": function($event) {
        _vm.confirmSelectAbilities()
      }
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-sm btn-default right m-r-sm",
    on: {
      "click": function($event) {
        _vm.cancelSelectAbilities()
      }
    }
  }, [_vm._v("取消")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.ability_select_show),
      expression: "!ability_select_show"
    }]
  }, [_c('draggable', {
    staticClass: "col-xs-12 m-t-sm list-group",
    attrs: {
      "options": {
        'draggable': '.list-group-item'
      }
    },
    model: {
      value: (_vm.post.abilities),
      callback: function($$v) {
        _vm.post.abilities = $$v
      },
      expression: "post.abilities"
    }
  }, _vm._l((_vm.post.abilities), function(ability, ind) {
    return _c('div', {
      key: ability.ability._id,
      staticClass: "list-group-item row m-b-md",
      class: {
        'open': ability.is_opend === 1
      }
    }, [_c('div', {
      staticClass: "btn col-xs-12 n-b-r btn-md btn-success"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-5"
    }, [_vm._v(_vm._s(ability.ability.name))]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-6"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-6"
    }), _vm._v(" "), _c('div', {
      staticClass: "col-xs-6"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "left"
    }, [_vm._v("权重：")]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-6 n-p-l"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (ability.weight),
        expression: "ability.weight",
        modifiers: {
          "number": true
        }
      }],
      staticStyle: {
        "width": "100%",
        "height": "18px",
        "font-size": "14px"
      },
      attrs: {
        "type": "number",
        "step": "0.01",
        "min": "0",
        "max": "100",
        "required": ""
      },
      domProps: {
        "value": (ability.weight)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          ability.weight = _vm._n($event.target.value)
        },
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "left tooltips"
    }, [_c('i', {
      staticClass: "fa fa-question-circle-o"
    }), _vm._v(" "), _c('div', {
      staticClass: "text"
    }, [_vm._v("\n                                      能力群权重是用来生成用户的综合能力得分。各能力群权重之和为100;权重为0时，该能力群不进行测评。\n                                    ")])])])])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-1"
    }, [_c('span', {
      staticClass: "right",
      on: {
        "click": function($event) {
          _vm.delAbility(ind)
        }
      }
    }, [_vm._v("x")])])])]), _vm._v(" "), _c('draggable', {
      staticClass: "col-xs-12 m-t-sm list-group-sub",
      attrs: {
        "options": {
          'draggable': '.list-group-sub-item'
        }
      },
      model: {
        value: (ability.indicators),
        callback: function($$v) {
          ability.indicators = $$v
        },
        expression: "ability.indicators"
      }
    }, _vm._l((ability.indicators), function(indicator, ind) {
      return _c('div', {
        key: indicator.indicator._id,
        staticClass: "list-group-sub-item"
      }, [_c('div', {
        staticClass: "btn col-xs-12 n-f",
        class: {
          'btn-success': ind % 3 === 2, 'btn-warning': ind % 3 === 1, 'btn-danger': ind % 3 === 0
        }
      }, [_c('div', {
        staticClass: "row"
      }, [_c('div', {
        staticClass: "col-xs-6"
      }, [_vm._v(_vm._s(indicator.indicator.name))]), _vm._v(" "), _c('div', {
        staticClass: "col-xs-6"
      }, [_c('div', {
        staticClass: "row"
      }, [_c('div', {
        staticClass: "left"
      }, [_vm._v("权重：")]), _vm._v(" "), _c('div', {
        staticClass: "col-xs-6"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model.number",
          value: (indicator.weight),
          expression: "indicator.weight",
          modifiers: {
            "number": true
          }
        }],
        staticStyle: {
          "width": "100%",
          "height": "18px"
        },
        attrs: {
          "type": "number",
          "step": "0.01",
          "min": "0",
          "max": "100",
          "required": ""
        },
        domProps: {
          "value": (indicator.weight)
        },
        on: {
          "input": [function($event) {
            if ($event.target.composing) { return; }
            indicator.weight = _vm._n($event.target.value)
          }, function($event) {
            _vm.validateWeight(ability, indicator)
          }],
          "blur": function($event) {
            _vm.$forceUpdate()
          }
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "left tooltips"
      }, [_c('i', {
        staticClass: "fa fa-question-circle-o"
      }), _vm._v(" "), _c('div', {
        staticClass: "text"
      }, [_vm._v("\n                                      指标权重用来生成用户的对应能力群得分。同一能力群下指标权重之和为100;权重为0时，该指标不进行测评，不计入能力群得分计算模型中。\n                                    ")])])])])])])])
    }))], 1)
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: " b-b b-dashed"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-2 text-right label p-t-b-sm"
  }, [_vm._v("\n                岗位说明:\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-10 n-p-l"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.post.desc),
      expression: "post.desc",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "placeholder": "备注",
      "id": "post-desc-editor"
    },
    domProps: {
      "value": (_vm.post.desc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.post.desc = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group text-center"
  }, [_c('div', {
    staticClass: "btn btn-primary m-r-md",
    on: {
      "click": function($event) {
        _vm.upsert()
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.clearEdit()
      }
    }
  }, [_vm._v("取消")])])])])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-479d2656","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/company/post/edit.vue
// module id = 478
// module chunks = 1